"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const InternalToExternalEnumMappings_1 = require("../../EnumMappings/InternalToExternalEnumMappings");
const TableauError_1 = require("../../TableauError");
const EnumConverter_1 = require("../../Utils/EnumConverter");
/**
 * Each ServceImpl should extend this base class for the sake of
 * proper error handling.  This base handles the conversion
 * from internal errors to external errors that we throw to developers
 */
class ServiceImplBase {
    constructor(_dispatcher, _registryId) {
        this._dispatcher = _dispatcher;
        this._registryId = _registryId;
    }
    execute(verb, params) {
        return this._dispatcher.execute(verb, params).catch((error) => {
            // Any internal error that comes from the dispatcher should be converted
            // to an external error using the enum mapper for error codes.
            const internalError = error;
            const externalErrorCode = InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.errorCode.convert(internalError.errorCode, EnumConverter_1.ShouldThrow.No);
            throw new TableauError_1.TableauError(externalErrorCode, internalError.message);
        });
    }
}
exports.ServiceImplBase = ServiceImplBase;
//# sourceMappingURL=ServiceImplBase.js.map